export default __webpack_public_path__ + "static/media/pexels-edward-eyer.c891b07a.jpg";